import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const SALARIES="salaries"
const SALARIES_COLABORADOR="salaries/colaboradores"
const PERIODS=`${SALARIES}/periods`
const PERIODS_COLABORADORES=`${PERIODS}/colaboradores`

export const salariesPost = (data) => {
    const controller= loadAbort()
    const call= axios.post(SALARIES,data,{signal:controller.signal})
    return {call,controller}
}
export const salariesColaboradorGet = (id,params) => {
    const controller= loadAbort()
    const call= axios.get(`${SALARIES_COLABORADOR}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}

export const salariesPDFGet = (id) => {
    const controller= loadAbort()
    const call= axios.get(`${SALARIES}/${id}`,{signal:controller.signal,responseType:"blob"})
    return {call,controller}
}
export const periodsGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(`${PERIODS}`,{params,signal:controller.signal})
    return {call,controller}
}
export const periodsColaboradoresGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(`${PERIODS_COLABORADORES}`,{params,signal:controller.signal})
    return {call,controller}
}

// export const documentPut = (documentsId,data) => {
//     const controller= loadAbort()
//     const call= axios.put(`${DOCUMENTS}/${documentsId}`,data,{signal:controller.signal})
//     return {call,controller}
// }
// export const documentDelete = (documentsId) => {
//     const controller= loadAbort()
//     const call= axios.delete(`${DOCUMENTS}/${documentsId}`,{signal:controller.signal})
//     return {call,controller}
// }
